import {createSlice} from '@reduxjs/toolkit'
import loadInitialStateObject from './initialStateUtil'

const notEligibleSlice = createSlice({
    name: 'notEligible',
    initialState : loadInitialStateObject('notEligible'),
    reducers : {}
})

export default notEligibleSlice.reducer